import {ExtendedShiftQuickSelectSlots} from '@hconnect/common'

export const SHIFT_QUICK_SELECT_SLOTS: ExtendedShiftQuickSelectSlots[] = [
  'today',
  'yesterday',
  'last7days',
  'currentMonth',
  'lastMonth'
]

export enum QuickSelectTimeRange {
  Today = 'today',
  Yesterday = 'yesterday',
  Last7days = 'last7days',
  CurrentMonth = 'currentMonth',
  LastMonth = 'lastMonth',
  CurrentShift = 'currentShift',
  PastShift = 'pastShift',
  Last24hours = 'last24hours',
  LastWeekend = 'lastWeekend',
  Last3days = 'last3days',
  Last30days = 'last30days'
}
